import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-3" };
const _hoisted_2 = { class: "flex items-center gap-1.5" };
const _hoisted_3 = { class: "text-base font-bold text-(--text-text-heading)" };
const _hoisted_4 = {
    key: 0,
    class: "flex flex-col gap-3.5"
};
const _hoisted_5 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
import { Button, Tooltip } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationSocialProfileSection',
    props: {
        profiles: {},
        canInteract: { type: Boolean },
        tooltip: {}
    },
    emits: ["edit"],
    setup(__props) {
        function profileUrl(profile) {
            const url = (profile.urlPrefix ?? "") + profile.value;
            return url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                        class: "ri-share-line text-xl text-(--text-text-heading)",
                        "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('organisation.detail.communication.socialLinksTitle')), 1 /* TEXT */)
                ]),
                (__props.profiles.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.profiles, (profile) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: profile.id,
                                class: "flex items-center justify-between"
                            }, [
                                _createVNode(_unref(Button), {
                                    as: "a",
                                    href: profileUrl(profile),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    variant: "secondary",
                                    size: "xs",
                                    "icon-left": profile.iconClass,
                                    label: profile.networkName ?? profile.networkCode
                                }, null, 8 /* PROPS */, ["href", "icon-left", "label"]),
                                _createVNode(_unref(Tooltip), {
                                    text: __props.tooltip,
                                    disabled: __props.canInteract,
                                    tabindex: !__props.canInteract ? 0 : undefined
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Button), {
                                            variant: "secondary",
                                            size: "xs",
                                            "icon-only": true,
                                            "icon-left": "ri-pencil-line",
                                            disabled: !__props.canInteract,
                                            "aria-label": _ctx.$t('socialProfile.common.editAriaLabel', { value: profile.networkName ?? profile.networkCode }),
                                            onClick: ($event) => (_ctx.$emit('edit', profile))
                                        }, null, 8 /* PROPS */, ["disabled", "aria-label", "onClick"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('socialProfile.common.noProfiles')), 1 /* TEXT */))
            ]));
        };
    }
});
